import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { createStyles, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import { Button, Header, Icon, Modal } from "semantic-ui-react";
import Settings from "@material-ui/icons/SettingsOutlined";
import ExitToApp from "@material-ui/icons/ExitToApp";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import Logo from "./logo";
import AppTitle from "./app_title";
import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
import Keys from "@utils/keys";
import m from "@utils/strings";

// Types
import { UserState } from "redux-oidc";

export interface IMenuAppBarProps
  extends React.ComponentPropsWithRef<"div">,
    UserState {
  classes?: any;
}

export type TOpenClosed = "open" | "closed";

export type ESideOptions = "left" | "right";

export interface IMenuAppBarState {
  auth: boolean;
  anchorEl: EventTarget | null;
  left: boolean;
  modal: TOpenClosed;
  menuLateral: TOpenClosed;
  redirectLink: string;
}

const styles = createStyles((theme: any) => ({
  grow: {
    flexGrow: 1,
  },
  divContainer: {
    color: "#00885f",
    backgroundColor: "#fff",
    boxShadow: "0 4px 2px -2px #AAA",
    marginTop: -3,
    position: "fixed",
    zIndex: 1,
  },
  autorizador: {
    flexGrow: 1,
    width: 120,
    height: 23,
    fontFamily: "Work Sans",
    fontSize: 20,
    fontWeight: 700,
    color: "#00885f !important",
    textDecoration: "none !important",
    left: "Calc(50% - 60px)",
    position: "absolute",
    top: 25,
  },
  logo: {
    margin: 10,
    marginLeft: 50,
    cursor: "pointer",
  },
  userLabel: {
    height: 16,
    color: "#9b9b9b",
    fontFamily: "Work Sans",
    fontSize: 14,
    fontWeight: 400,
  },
  userArrow: {
    color: "#9b9b9b",
    width: 24,
    height: 24,
  },
  userIcon: {
    width: 41,
    height: 41,
    color: "#9b9b9b",
  },
  alignRight: {
    position: "absolute",
    float: "right",
    right: 0,
  },
  profileMenuIcon: {
    width: 25,
    height: 25,
    color: "#9b9b9b",
  },
  sectionDesktop: {
    display: "flex",
    flexDirection: "row",
  },
  root: {
    width: "100%",
  },
  drawerPaper: {
    position: "relative",
    width: 300,
    boxShadow: "4px 0 4px 0 rgba(0,0,0,0.12)",
  },
  modalPaper: {
    top: "70px !important",
  },
  backdrop: {
    backgroundColor: "rgba(0, 0, 0, 0) !important",
    top: "70px !important",
  },
}));

function MenuAppBar(props: IMenuAppBarProps) {
  const navigate = useNavigate();
  const [state, setState] = useState<IMenuAppBarState>({
    auth: true,
    anchorEl: null,
    left: false,
    modal: "closed",
    menuLateral: "closed",
    redirectLink: "/",
  });

  const isModalOpened = state.modal == "open";

  const isModalMenuLateralOpened = state.menuLateral == "open";

  const handleMenu = (
    event: React.MouseEvent<SVGSVGElement> | React.MouseEvent<HTMLLabelElement>
  ) => {
    setState((prevState) => ({
      ...prevState,
      anchorEl: event.currentTarget,
    }));
  };

  const handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      anchorEl: null,
    }));
  };

  const handleLogout = () => {
    if (!props?.user) return;
    const id_token_hint = props.user.id_token;
    const logoutUri = `${
      Keys.IDENTITY_SERVER.AUTHORITY
    }/connect/endsession?id_token_hint=${id_token_hint}&post_logout_redirect_uri=${
      window.location.protocol
    }//${window.location.hostname}${
      window.location.port ? `:${window.location.port}` : ""
    }/callback`;
    window.location.assign(logoutUri);
  };

  const toggleDrawer = (side: ESideOptions, open: boolean) => () => {
    setState((prevState) => ({
      ...prevState,
      [side]: open,
    }));
  };

  const openModal = () => {
    const url = window.location.href;
    if (
      url.includes("atendimento/e") ||
      url.includes("atendimento/c") ||
      url.includes("cadastrar-editar-profissional")
    ) {
      handleMenuStateChange("open", "modal");
    } else {
      navigate("/");
    }
  };

  const openMenuLateralModal = (redirectLink: string) => {
    const url = window.location.href;
    if (url.includes(redirectLink)) return;
    else {
      const rootUrlWithProtocol = `${window.location.protocol}//${
        window.location.hostname
      }${window.location.port ? `:${window.location.port}` : ""}/`;
      const rootUrlWithoutProtocol = `${window.location.hostname}${
        window.location.port ? `:${window.location.port}` : ""
      }/`;
      if (
        url === rootUrlWithProtocol ||
        url === rootUrlWithoutProtocol ||
        url === rootUrlWithProtocol + "atendimento" ||
        url === rootUrlWithoutProtocol + "atendimento"
      ) {
        navigate(redirectLink);
      }
      handleMenuStateChange("open", "menuLateral", redirectLink);
    }
  };

  const handleMenuStateChange = (
    state: TOpenClosed = "open",
    menu: "modal" | "menuLateral" = "modal",
    redirectLink: string = "/"
  ) => {
    setState((prevState) => ({
      ...prevState,
      [menu]: state,
      redirectLink,
    }));
  };

  const render = () => {
    let userInfo: string;
    const { user, classes } = props;
    const { anchorEl } = state;
    const open = Boolean(anchorEl);

    if (user) {
      userInfo = `${user.profile.given_name} ${user.profile.family_name}`;
    } else {
      userInfo = m.GERAL.LABEL_USUARIO_GENERICO;
    }

    const sideList = (
      <div>
        <div className="div-separador-10" />
        <div
          id="sidebar-list"
          onClick={() => {
            openMenuLateralModal("/reimpressao-de-guias");
          }}
        >
          <img
            src="../images/print-sidebar.png"
            alt="reimpressao-icon"
            id="img-sidebar-margin"
          />
          {m.GERAL.LABEL_MENU_REIMPRESSAO_GUIAS}
        </div>
        <Divider id="sidebar-divider" />
        <div
          id="sidebar-list"
          onClick={() => {
            openMenuLateralModal("/profissionais-executantes");
          }}
        >
          <img
            src="../images/user-sidebar.png"
            alt="profissionais-icon"
            id="img-sidebar-margin"
          />
          {m.GERAL.LABEL_MENU_PROFISSIONAIS_EXECUTANTES}
        </div>
        <Divider id="sidebar-divider" />
        <div
          id="sidebar-list"
          onClick={() => {
            openMenuLateralModal("/lote-cobranca");
          }}
        >
          <img
            src="../images/cobranca-sidebar.png"
            alt="cobranca-icon"
            id="img-sidebar-margin"
            style={{ float: "left" }}
          />
          {m.GERAL.LABEL_MENU_GERACAO_LOTE_COBRANCA}
        </div>
      </div>
    );

    return (
      <div>
        <Drawer
          open={state.left}
          onClose={toggleDrawer("left", false)}
          ModalProps={{
            BackdropProps: { classes: { root: classes.backdrop } },
          }}
          classes={{
            paper: classes.drawerPaper,
            modal: classes.modalPaper,
          }}
        >
          <div
            tabIndex={0}
            role="button"
            onClick={toggleDrawer("left", false)}
            onKeyDown={toggleDrawer("left", false)}
          >
            {sideList}
          </div>
        </Drawer>

        <AppBar position="static" className={classes.divContainer}>
          <Toolbar>
            <div style={{ cursor: "pointer" }} onClick={openModal}>
              <Logo classes={classes} />
            </div>

            <div
              className={classes.margin}
              style={{ marginRight: 25, marginLeft: 5, marginTop: -38 }}
            >
              <div className="app-bar-separator" />
            </div>

            <div
              id="menu-button-sidebar"
              onClick={toggleDrawer("left", !state.left)}
            >
              <img
                id="menu-hamburguer-icon-sidebar"
                src="../images/menu-sidebar.png"
                alt="menu-icon"
              />
              {m.GERAL.LABEL_MENU}
            </div>

            <div style={{ cursor: "pointer" }} onClick={openModal}>
              <AppTitle classes={classes} />
            </div>

            <div className={classes.grow} />
            <div className={classes.sectionDesktop}>
              <div
                className={classes.margin}
                style={{ marginTop: 10, marginRight: 17, cursor: "pointer" }}
                onClick={openModal}
              >
                <img
                  style={{ width: 30 }}
                  src="../images/home.png"
                  alt="HOME"
                />
              </div>

              <div
                className={classes.margin}
                style={{ marginRight: 40, marginTop: 5 }}
              >
                <div className="app-bar-separator" />
              </div>

              <div className={classes.margin} style={{ cursor: "pointer" }}>
                <div className={"divContainerInterno"} id="container-logout">
                  <div className={"divExterior"}>
                    <div className={"divInterior"}>
                      <div style={{ height: 50 }}>
                        <div
                          className={"divContainerInterno"}
                          style={{ marginRight: 10 }}
                        >
                          <div className={"divExterior"}>
                            <div className={"divInterior"}>
                              <img
                                style={{ width: 30 }}
                                src="../images/user.png"
                                alt="USER"
                              />
                            </div>
                          </div>
                        </div>
                        <div className={"divContainerInterno"}>
                          <div className={"divExterior"}>
                            <div className={"divInterior"}>
                              <label
                                onClick={handleMenu}
                                className={classes.userLabel}
                                style={{ cursor: "pointer" }}
                                aria-haspopup="true"
                                aria-owns={open ? "menu-appbar" : undefined}
                              >
                                {userInfo}
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className={"divContainerInterno"}>
                          <div className={"divExterior"}>
                            <div className={"divInterior"}>
                              <KeyboardArrowDown
                                className={classes.userArrow}
                                onClick={handleMenu}
                                style={{ height: 50 }}
                              />
                            </div>
                          </div>
                        </div>
                        <Menu
                          id="menu-appbar"
                          anchorEl={anchorEl as Element}
                          anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                          open={open}
                          onClose={handleClose}
                        >
                          <MenuItem onClick={handleClose}>
                            <Settings
                              className={classes.profileMenuIcon}
                              style={{ marginRight: 5 }}
                            />
                            {m.GERAL.LABEL_PROFILE}
                          </MenuItem>
                          <MenuItem onClick={handleLogout}>
                            <ExitToApp
                              className={classes.profileMenuIcon}
                              style={{ marginRight: 5 }}
                            />
                            {m.GERAL.LABEL_DESLOGAR}
                          </MenuItem>
                        </Menu>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Toolbar>
        </AppBar>
        <Modal
          open={isModalOpened}
          className="modal-layout-back-home scrolling"
        >
          <Header
            content={m.GERAL.MODAL_TITULO_VOLTAR_TELA_HOME}
            className={"form-header-title"}
          />
          <Modal.Content>
            <p className="modal-description-text">
              {m.GERAL.MODAL_MENSAGEM_VOLTAR_TELA_HOME}
            </p>
          </Modal.Content>
          <Modal.Actions>
            <Button color="red" onClick={() => handleMenuStateChange("closed")}>
              <Icon name="remove" /> {m.GERAL.MODAL_LABEL_NAO}
            </Button>
            <Link to="/">
              <Button icon labelPosition="right">
                <Icon name="arrow right" /> {m.GERAL.MODAL_LABEL_SIM}
              </Button>
            </Link>
          </Modal.Actions>
        </Modal>
        <Modal
          open={isModalMenuLateralOpened}
          className="modal-layout-trocar-tela scrolling"
        >
          <Header
            content={m.GERAL.MODAL_TITULO_TROCAR_DE_TELA}
            className={"form-header-title"}
          />
          <Modal.Content>
            <p className="modal-description-text">
              {m.GERAL.MODAL_MESANGEM_TROCAR_DE_TELA}
            </p>
          </Modal.Content>
          <Modal.Actions>
            <Button
              color="red"
              onClick={() => {
                handleMenuStateChange("closed", "menuLateral");
              }}
            >
              <Icon name="remove" /> {m.GERAL.MODAL_LABEL_NAO}
            </Button>
            <Link to={state.redirectLink}>
              <Button icon labelPosition="right">
                <Icon name="arrow right" /> {m.GERAL.MODAL_LABEL_TROCAR}
              </Button>
            </Link>
          </Modal.Actions>
        </Modal>
      </div>
    );
  };

  return render();
}

export default withStyles(styles)(MenuAppBar);
